import { states } from "../../../../../legacyComponents/util/constants"

export default function getDefaultDependent(user) {
	return {
		firstName: "",
		lastName: "",
		relationship: "",
		dateOfBirth: null,
		gender: "",
		addressLine1: user?.addressLine1 || "",
		addressLine2: user?.addressLine2 || "",
		city: user?.city || "",
		state: states?.[user?.state] || "",
		zip: user?.zip || ""
	}
}
